<template>
    <div class="mx-auto col-12 col-sm-8 col-lg-4 mt-4">
        <b-card>
            <h2 slot="header">Регистрация в DriveCRM</h2>

            <form class="loginForm" @submit.prevent="register">
                <div class="form-group">
                    <label for="userName">Имя пользователя</label>
                    <input id="userName" class="form-control" required v-model="user.username" type="text"
                           placeholder="Введите ваше имя пользователя"/>
                </div>
                <div class="form-group">
                    <label for="email">Электронная почта</label>
                    <input id="email" class="form-control" required v-model="user.email" type="text"
                           placeholder="Введите вашу электронную почту"/>
                </div>
                <div class="form-group">
                    <label for="password">Пароль</label>
                    <input id="password" class="form-control" required v-model="user.password" type="password"
                           placeholder="Пароль"/>
                </div>
                <hr/>
                <button class="btn btn-primary" type="submit">Зарегистрироваться</button>
            </form>
            <div v-if="error">
                <div class="alert alert-danger" role="alert">
                    {{error}}
                </div>
            </div>
        </b-card>
    </div>
</template>


<script>
    import axios from 'axios';
    import {AUTH_SUCCESS} from "../../store/actions/auth";
    import {APP_STATE_REQUEST} from "../../store/actions/app";

    export default {
        name: 'register',
        data() {
            return {
                error: undefined,
                user: {
                    username: '',
                    email: '',
                    password: '',
                }
            }
        },
        methods: {
            register: function () {
                this.error = undefined;

                axios.post('/api/auth/register', this.user)
                    .then(resp => {
                            if (resp.data.status === 'success') {
                                const token = resp.data.data.token;

                                this.$store.commit(AUTH_SUCCESS, token);
                                this.$store.dispatch(APP_STATE_REQUEST);

                                this.$router.push('/')
                            } else {
                                this.error = resp.data.data;
                                console.log(this.error);
                            }
                        }
                    )
                    .catch(err => {
                        console.log(err);
                        this.error = err;
                    });
            }
        },
    }
</script>

<style scoped>
    .loginForm {
        display: flex;
        flex-direction: column;

        padding: 10px;
        margin: 0 auto;
    }
</style>
